import React from 'react'
import styled from 'styled-components'

import CenteredLoader from 'components/lib/CenteredLoader'

const Root = styled.div`
  min-height: 100%;
`

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);

  /* New nav: fill the content area between the top bar/banner and the page inset. */
  .platform-nav-content & {
    min-height: calc(
      100vh - var(--top-bar-height, 52px) - var(--banner-height, 0px) -
        (var(--page-inset, 20px) * 2)
    );
  }
`

const Placeholder = () => (
  <Root id="module-placeholder">
    <LoaderWrapper>
      <CenteredLoader />
    </LoaderWrapper>
  </Root>
)

export default Placeholder
